<template>
    <div>
        <h3>道具包活动配置</h3>
        <el-form :inline="true" class="demo-form-inline" :loading="loading" size="mini">
            <el-form-item label="道具包编号">
                <el-input placeholder="道具包编号" v-model="filter.toolId"></el-input>
            </el-form-item>
            <el-form-item label="道具包名称">
                <el-input placeholder="道具包名称" v-model="filter.propName"></el-input>
            </el-form-item>
            <el-form-item label="活动文案">
                <el-input placeholder="活动文案" v-model="filter.remark"></el-input>
            </el-form-item>
            <el-form-item label="活动编号">
                <el-input placeholder="活动编号" v-model="filter.id"></el-input>
            </el-form-item>

            <el-form-item label="状态">
                <el-select v-model="filter.propStatus">
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="(label, key) in propStatus" :key="key" :label="label" :value="key"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="活动类型">
                <el-select v-model="filter.activityType">
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="(label, key) in activityType" :key="key" :label="label" :value="key"></el-option>
                    <!-- <el-option label="人才沟通消耗" value="-3"></el-option> -->
                </el-select>
            </el-form-item>

            <el-form-item label="开始时间">
                <el-date-picker v-model="filter.startTimeStart" type="datetime" placeholder="开始时间"
                    format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="到">
                <el-date-picker v-model="filter.startTimeEnd" type="datetime" placeholder="结束时间"
                    format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
            </el-form-item>

            <el-form-item label="结束时间">
                <el-date-picker v-model="filter.endTimeStart" type="datetime" placeholder="开始时间"
                    format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="到">
                <el-date-picker v-model="filter.endTimeEnd" type="datetime" placeholder="结束时间" format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
            </el-form-item>

            <el-form-item label="创建时间">
                <el-date-picker v-model="filter.createTimeStart" type="datetime" placeholder="开始时间"
                    format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="到">
                <el-date-picker v-model="filter.createTimeEnd" type="datetime" placeholder="结束时间"
                    format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" size="mini" @click="fetch(1)">查询</el-button>
                <el-button type="primary" size="mini" @click="rest()">重置</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="list" size="mini">
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column prop="toolId" label="道具包编号"></el-table-column>
            <el-table-column prop="propName" label="道具包名称"></el-table-column>
            <el-table-column prop="packageImg" label="活动图片">
                <template slot-scope="scope">
                    <img style="width: 60px;height: 60px;" :src="scope.row.packageImg" alt="">
                </template>
            </el-table-column>
            <el-table-column prop="remark" label="活动文案"></el-table-column>
            <el-table-column prop="propStatus" label="状态">
                <template slot-scope="scope">{{
                    propStatus[scope.row.propStatus]
                }}</template>
            </el-table-column>
            <el-table-column prop="saleCount" label="销量"></el-table-column>
            <el-table-column prop="discount" label="活动折扣"></el-table-column>
            <el-table-column prop="discountPrice" label="活动价"></el-table-column>
            <el-table-column prop="activityType" label="活动类型">
                <template slot-scope="scope">{{
                    activityType[scope.row.activityType]
                }}</template>
            </el-table-column>
            <el-table-column prop="includePresentNum" label="活动加量"></el-table-column>
            <el-table-column prop="actPurchaseLimit" label="活动限购量"></el-table-column>
            <el-table-column prop="accPurchaseLimit" label="账户限购量"></el-table-column>
            <el-table-column prop="actDays" label="活动天数"></el-table-column>
            <el-table-column prop="id" label="活动编号"></el-table-column>
            <el-table-column prop="startTime" label="开始时间" width="180"></el-table-column>
            <el-table-column prop="endTime" label="结束时间" width="180"></el-table-column>
            <el-table-column prop="createUser" label="创建人"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="180"></el-table-column>
            <el-table-column prop="operator" label="操作人"></el-table-column>
            <el-table-column prop="operateTime" label="操作时间" width="180"></el-table-column>
            <!-- <el-table-column prop="role" label="操作"></el-table-column> -->
        </el-table>
        <br />
        <div>
            <el-pagination background layout="prev, pager, next" :page-size="limit" @current-change="(i) => (pageNum = i)"
                :page-count="pageNum" :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import map from "../../../datamap";
import api from "../../api";
// import newApi from "@/newApi/bean.js";

let { prop } = api;
export default {
    name: "partyBorder",
    data() {
        return {
            map,
            loading: true,
            types: {},
            filter: {
                toolId: "",
                propName: "",
                propType: 2,
                remark: "",
                propStatus: "",
                activityType: "",
                id: '',
                startTimeStart: "",
                startTimeEnd: "",
                endTimeStart: '',
                endTimeEnd: '',
                createTimeStart: '',
                createTimeEnd: ''
            },
            list: [],
            total: 0,
            pageNum: 1,
            limit: 20,
            propStatus: {
                1: "未开始",
                2: "进行中",
                3: "已结束",
                4: "已终止",
            },
            activityType: {
                0: "通用（默认）",
                1: "首购活动",
                2: "折扣活动",
                3: "加量活动",
                4: "折扣加量",
            },

        };
    },
    watch: {
        pageNum() {
            this.fetch();
        },
    },
    methods: {
        async fetch(num) {
            if (num == 1) {
                this.pageNum = 1;
            }
            this.filter.pageNum = this.pageNum
            this.filter.limit = this.limit
            let res = await prop.selectProps(this.filter);
            this.list = res.data.data;
            this.total = res.data.pageinfo.totalCount;
        },
        async getTypes() {
            let res = await prop.types();
            this.types = res.data.data;
        },
        async rest() {
            this.filter = {
                toolId: "",
                propName: "",
                propType: 2,
                remark: "",
                propStatus: "",
                activityType: "",
                id: '',
                startTimeStart: "",
                startTimeEnd: "",
                endTimeStart: '',
                endTimeEnd: '',
                createTimeStart: '',
                createTimeEnd: ''
            }
            this.fetch(1);

        },
        // async exportExcel() {
        //     this.loading = true;
        //     this.filter.pageNum = this.pageNum
        //     this.filter.limit = this.limit
        //     let resp = await prop.export(this.filter);
        //     let objectUrl = URL.createObjectURL(new Blob([resp.data]));
        //     let link = document.createElement("a");
        //     //   console.log(link);
        //     link.download = decodeURIComponent("云豆明细列表.xlsx");
        //     link.href = objectUrl;
        //     link.click();
        // },
    },
    mounted() {
        this.fetch(1);
    },
};
</script>
<style></style>


// WEBPACK FOOTER //
// src/views/prop/partyB/activityConfig.vue